import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-7e45255e")
const _hoisted_1 = { class: "page" }
const _hoisted_2 = { class: "p-grid" }
const _hoisted_3 = { class: "p-col-12 p-md-4 p-lg-3" }
const _hoisted_4 = { class: "toolbar__left p-fluid w100" }
const _hoisted_5 = { class: "p-mt-3 p-d-flex p-flex-column" }
const _hoisted_6 = {
  for: "file",
  class: "p-button"
}
const _hoisted_7 = { class: "p-d-flex w100" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-file-excel p-mr-2" }, null, -1)
const _hoisted_9 = { class: "w100 p-text-center" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Seleziona file")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Sostituisci file")
const _hoisted_12 = { class: "p-m-3 p-text-center text-wrap" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, " File selezionato: ", -1)
const _hoisted_14 = ["title"]
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Nessun file selezionato")
const _hoisted_16 = { class: "p-col-12 p-md-8 p-lg-9" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-times p-mr-2 p-badge p-badge-danger" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "p-panel-title" }, "Ordini da controllare", -1)
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "w100 p-text-right" }, null, -1)
const _hoisted_21 = { class: "p-d-flex p-flex-column p-jc-center p-ai-center p-flex-sm-row p-jc-sm-between" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "p-mb-4" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, "Attenzione!"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" In questa tabella verranno visualizzati solo gli ordini la cui creazione ha avuto esito negativo. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" Nella colonna "),
    /*#__PURE__*/_createElementVNode("b", null, "\"Errori\""),
    /*#__PURE__*/_createTextVNode(" troverai una descrizione dell' "),
    /*#__PURE__*/_createElementVNode("span", { class: "p-error" }, "errore"),
    /*#__PURE__*/_createTextVNode(". Una volta corretto clicca sul pulsante "),
    /*#__PURE__*/_createElementVNode("i", null, "\"Riprova\""),
    /*#__PURE__*/_createTextVNode(" per ritentare la creazione degli ordini. ")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Qualora sia necessario puoi cliccare il pulsante "),
    /*#__PURE__*/_createElementVNode("i", null, "\"Scarica\""),
    /*#__PURE__*/_createTextVNode(" per poterlo poi ricaricare in un secondo momento e terminare la procedura. ")
  ])
], -1)
const _hoisted_23 = {
  class: "p-d-flex",
  style: {"min-width":"200px"}
}
const _hoisted_24 = { class: "p-fluid" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check p-mr-2 p-badge p-badge-success" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "p-panel-title" }, "Ordini caricati correttamente", -1)
const _hoisted_27 = { key: 0 }
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageHeader = _resolveComponent("PageHeader")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_TimeslotSelect = _resolveComponent("TimeslotSelect")!
  const _component_ZoneAutocomplete = _resolveComponent("ZoneAutocomplete")!
  const _component_CustomerAutocomplete = _resolveComponent("CustomerAutocomplete")!
  const _component_PickerAutocomplete = _resolveComponent("PickerAutocomplete")!
  const _component_VehicleAutocomplete = _resolveComponent("VehicleAutocomplete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Panel = _resolveComponent("Panel")!
  const _component_Column = _resolveComponent("Column")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_AddressAutocomplete = _resolveComponent("AddressAutocomplete")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ProgressDialog = _resolveComponent("ProgressDialog")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageHeader, {
      showDelete: false,
      showSave: false,
      title: _ctx.$t('orders.import.title')
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Panel, {
          class: "p-mb-3",
          header: "Dati principali",
          collapsed: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_FloatLabel, {
                label: "Data",
                class: "w100 p-fluid"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Calendar, {
                    modelValue: _ctx.date,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.date = $event)),
                    placeholder: "Seleziona giorno",
                    showIcon: "",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_TimeslotSelect, {
                class: "w100 timeslot_select",
                modelValue: _ctx.shift,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.shift = $event)),
                required: "",
                onChange: _ctx.onTimeslotChange
              }, null, 8, ["modelValue", "onChange"]),
              _createVNode(_component_FloatLabel, {
                label: "Città",
                class: "p-fluid"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ZoneAutocomplete, {
                    modelValue: _ctx.zone,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.zone = $event)),
                    onResultSelected: _ctx.onZoneSelect
                  }, null, 8, ["modelValue", "onResultSelected"])
                ]),
                _: 1
              }),
              _createVNode(_component_FloatLabel, {
                label: "Cliente",
                class: "p-fluid"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomerAutocomplete, {
                    dropdown: "",
                    modelValue: _ctx.customer,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.customer = $event)),
                    onResultSelected: _ctx.onCustomerSelect
                  }, null, 8, ["modelValue", "onResultSelected"])
                ]),
                _: 1
              }),
              _createVNode(_component_FloatLabel, {
                label: "Picker",
                class: "p-fluid"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_PickerAutocomplete, {
                    dropdown: "",
                    modelValue: _ctx.picker,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.picker = $event)),
                    disabled: !_ctx.customer,
                    customerId: _ctx.customer?.id,
                    zoneId: _ctx.zone?.id,
                    type: _ctx.pickerType
                  }, null, 8, ["modelValue", "disabled", "customerId", "zoneId", "type"])
                ]),
                _: 1
              }),
              _createVNode(_component_FloatLabel, {
                label: "Tipologia",
                class: "p-fluid"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_VehicleAutocomplete, {
                    modelValue: _ctx.vehicle,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.vehicle = $event)),
                    dropdown: "",
                    ids: _ctx.excludedVehiclesIds
                  }, null, 8, ["modelValue", "ids"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("label", _hoisted_6, [
                _createElementVNode("input", {
                  hidden: "",
                  id: "file",
                  type: "file",
                  name: "file",
                  accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/json",
                  multiple: false,
                  onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
                }, null, 32),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, [
                    (!_ctx.file)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _hoisted_10
                        ], 64))
                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                          _hoisted_11
                        ], 64))
                  ])
                ])
              ], 512), [
                [_directive_ripple]
              ]),
              _createElementVNode("div", _hoisted_12, [
                (_ctx.file)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _hoisted_13,
                      _createElementVNode("span", {
                        title: _ctx.file.name
                      }, _toDisplayString(_ctx.file.name), 9, _hoisted_14)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_15
                    ], 64))
              ]),
              _createElementVNode("span", null, [
                (_ctx.isJson)
                  ? (_openBlock(), _createBlock(_component_Button, {
                      key: 0,
                      label: "Riprendi da qui",
                      icon: "pi pi-upload",
                      class: "w100",
                      disabled: !_ctx.file,
                      onClick: _ctx.restore
                    }, null, 8, ["disabled", "onClick"]))
                  : (_openBlock(), _createBlock(_component_Button, {
                      key: 1,
                      label: "Conferma e carica",
                      icon: "pi pi-upload",
                      class: "w100",
                      disabled: !_ctx.file,
                      onClick: _ctx.uploadFile
                    }, null, 8, ["disabled", "onClick"]))
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_Panel, {
          class: "p-mb-3",
          toggleable: true,
          collapsed: _ctx.isDefectivePanelCollapsed,
          "onUpdate:collapsed": _cache[7] || (_cache[7] = ($event: any) => (_ctx.isDefectivePanelCollapsed = $event))
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", null, [
              _hoisted_17,
              _hoisted_18,
              (_ctx.ordersDefective?.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_19, " (Totale: " + _toDisplayString(_ctx.ordersDefective?.length) + ") ", 1))
                : _createCommentVNode("", true)
            ]),
            _hoisted_20
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_Button, {
                  label: "Riprova",
                  icon: "pi pi-refresh",
                  onClick: _ctx.retry,
                  disabled: !_ctx.ordersDefective?.length
                }, null, 8, ["onClick", "disabled"]),
                _createVNode(_component_Button, {
                  label: "Scarica",
                  icon: "pi pi-download",
                  class: "p-button-danger p-ml-2",
                  onClick: _ctx.downloadDefected
                }, null, 8, ["onClick"])
              ])
            ]),
            _createVNode(_component_DataTable, {
              ref: "dt",
              value: _ctx.ordersDefective,
              loading: _ctx.requestPending,
              rows: 10,
              "rows-per-page-options": [10, 20, 50, 100],
              paginator: true,
              "auto-layout": "",
              "striped-rows": "",
              responsiveLayout: "scroll",
              breakpoint: "2500px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  header: "Errori",
                  style: {"min-width":"250px"}
                }, {
                  body: _withCtx(({data}) => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.validation_errors, (e, i) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: `error_index_${i}`,
                        class: "p-error"
                      }, _toDisplayString(e), 1))
                    }), 128))
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  header: "Codice",
                  style: {"min-width":"150px"}
                }, {
                  body: _withCtx(({data}) => [
                    _createVNode(_component_InputText, {
                      modelValue: data.external_client_code,
                      "onUpdate:modelValue": ($event: any) => (data.external_client_code = $event),
                      class: "short-input"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  header: "Dati destinatario",
                  style: {"min-width":"300px"}
                }, {
                  body: _withCtx(({data}) => [
                    _createElementVNode("div", _hoisted_24, [
                      _createVNode(_component_FloatLabel, {
                        class: "p-field",
                        label: "Nome"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InputText, {
                            modelValue: data.dropoff_picker_name,
                            "onUpdate:modelValue": ($event: any) => (data.dropoff_picker_name = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_FloatLabel, {
                        class: "p-field",
                        label: "Tel."
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InputText, {
                            modelValue: data.dropoff_phone,
                            "onUpdate:modelValue": ($event: any) => (data.dropoff_phone = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_AddressAutocomplete, {
                        label: "Indirizzo di consegna",
                        modelValue: data.dropoff_full_address,
                        "onUpdate:modelValue": ($event: any) => (data.dropoff_full_address = $event),
                        onSelectedAddress: ($event: any) => (_ctx.onSelectAddress(data, $event))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onSelectedAddress"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, { header: "N° Colli" }, {
                  body: _withCtx(({data}) => [
                    _createVNode(_component_InputNumber, {
                      modelValue: data.items_qty,
                      "onUpdate:modelValue": ($event: any) => (data.items_qty = $event),
                      class: "qty-input"
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  header: "Note Consegna",
                  style: {"min-width":"250px"}
                }, {
                  body: _withCtx(({data}) => [
                    _createVNode(_component_Textarea, {
                      modelValue: data.note_supplier,
                      "onUpdate:modelValue": ($event: any) => (data.note_supplier = $event)
                    }, null, 8, ["modelValue", "onUpdate:modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value", "loading"])
          ]),
          _: 1
        }, 8, ["collapsed"]),
        _createVNode(_component_Panel, {
          class: "p-mb-3",
          toggleable: true,
          collapsed: _ctx.isCreatedPanelCollapsed,
          "onUpdate:collapsed": _cache[8] || (_cache[8] = ($event: any) => (_ctx.isCreatedPanelCollapsed = $event))
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", null, [
              _hoisted_25,
              _hoisted_26,
              (_ctx.ordersCreated?.length)
                ? (_openBlock(), _createElementBlock("span", _hoisted_27, " (Totale: " + _toDisplayString(_ctx.ordersCreated?.length) + ") ", 1))
                : _createCommentVNode("", true)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_DataTable, {
              ref: "dt",
              value: _ctx.ordersCreated,
              loading: _ctx.requestPending,
              rows: 10,
              "rows-per-page-options": [10, 20, 50, 100],
              paginator: true,
              "auto-layout": "",
              "striped-rows": "",
              responsiveLayout: "scroll",
              breakpoint: "1368px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  header: "Codice",
                  field: "external_client_code"
                }),
                _createVNode(_component_Column, {
                  header: "Destinatario",
                  field: "dropoff_picker_name"
                }),
                _createVNode(_component_Column, {
                  header: "Tel. Destinatario",
                  field: "dropoff_phone"
                }),
                _createVNode(_component_Column, {
                  header: "Indirizzo di consegna",
                  field: "dropoff_full_address"
                }),
                _createVNode(_component_Column, {
                  header: "N° Colli",
                  field: "items_qty"
                }),
                _createVNode(_component_Column, {
                  header: "Note Consegna",
                  field: "note_supplier"
                })
              ]),
              _: 1
            }, 8, ["value", "loading"])
          ]),
          _: 1
        }, 8, ["collapsed"])
      ])
    ]),
    _createVNode(_component_ProgressDialog, {
      visible: _ctx.displayProgress,
      "onUpdate:visible": _cache[9] || (_cache[9] = ($event: any) => (_ctx.displayProgress = $event))
    }, null, 8, ["visible"])
  ]))
}